import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './reset.sass';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <GoogleReCaptchaProvider reCaptchaKey={'6LenTlUrAAAAADpYh0L6Hjbbte25akn6e3zWHe_Y'} language={'en-US'}>
          <App />
      </GoogleReCaptchaProvider>
  </React.StrictMode>
);
